import { AfterViewInit, Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { Subject, startWith, delay, takeUntil } from 'rxjs';
import { MainLayoutService } from '@core/services/main-layout/main-layout.service';
import { HeaderComponent } from '../header/header.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { navBarData } from '../nav-bar/model/nav-bar-data';

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}
@Component({
  selector: 'app-main-layout',
  standalone: true,
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  imports: [
    CommonModule,
    NavBarComponent,
    HeaderComponent,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
  ],
})
export class MainLayoutComponent implements AfterViewInit, OnDestroy {
  // all injected service
  public router = inject(Router);
  public mainLayoutService = inject(MainLayoutService);

  // all variables
  sideBarOpen = true;
  isSideNavCollapsed = false;
  screenWidth = 0;
  collapsed = false;
  menu: unknown;
  asideBar: boolean | null = null;
  onDestroy$: Subject<boolean> = new Subject();
  navData = navBarData;

  // lifecycle hooks
  ngAfterViewInit(): void {
    this.mainLayoutService.shouldAsidebar
      .pipe(startWith(null), delay(0), takeUntil(this.onDestroy$))
      .subscribe(value => (this.asideBar = value));
  }

  // other methods
  OnToggleNavBar(data: SideNavToggle): void {
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
    this.collapsed = data.collapsed;
    this.mainLayoutService.collapsed.set(data.collapsed);
    this.mainLayoutService.isNavbarCollapsed.next(this.collapsed);
  }

  sideBarToggler(): void {
    this.sideBarOpen = !this.sideBarOpen;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
